import { j as D } from "../../../../jsx-runtime-CQ7OqOhn.js";
import F from "../TextField.js";
const N = ({
  id: u,
  onChange: e,
  onBlur: o,
  value: m,
  isWholeCurrency: s = !1,
  placeholder: f,
  ...g
}) => {
  const n = f ?? (s ? "$0" : "$0.00"), p = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: s ? 0 : 2
  }), i = /[^\d]/g, c = (t) => p.format(Number(t.replace(i, ""))), d = (t) => {
    const { value: a } = t.target, l = a.split(".");
    if (l.length === 1)
      t.target.value = c(a), e(t);
    else if (l.length === 2 && !s) {
      const r = c(l[0]), $ = l[1].replace(i, "").substring(0, 2);
      t.target.value = `${r}.${$}`, e(t);
    } else if (l.length === 2 && s) {
      const r = c(l[0]);
      t.target.value = r, e(t);
    }
  }, x = (t) => {
    var r;
    const { value: a } = t.target, l = (r = a.split(".")[1]) == null ? void 0 : r.length;
    l === 1 ? (t.target.value = `${a}0`, e(t)) : l === 0 ? (t.target.value = `${a}00`, e(t)) : l === void 0 && a !== "" && !s && (t.target.value = `${a}.00`, e(t)), o && o(t);
  };
  return /* @__PURE__ */ D.jsx(
    F,
    {
      ...g,
      id: u,
      onChange: d,
      placeholder: n,
      onBlur: x,
      type: "text",
      value: m
    }
  );
};
export {
  N as default
};
